import type { IPersonFields } from '@mentimeter/content-contentful/legacy/types/generated/contentful';

export const getPersonFullName = ({ name, lastName }: Partial<IPersonFields>) =>
  `${name}${lastName ? ` ${lastName}` : ''}`;
